(function () {
  function readVariant(script) {
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (err) { return null; }
  }

  function findVariantScript(scope) {
    return scope.querySelector('variant-picker script[data-variant]') || document.querySelector('variant-picker script[data-variant]');
  }

  function applyVariant(root, variant) {
    if (!variant) return;
    var image = variant.featured_image;
    if (!image || !image.src) return;

    var frame = root.querySelector('.selected-color-image__frame');
    if (!frame) return;

    var src = image.src;
    if (src.indexOf('//') === 0) src = window.location.protocol + src;

    var img = frame.querySelector('img');
    if (img) {
      img.src = src;
      img.srcset = '';
      img.alt = variant.public_title || variant.title || '';
    }

    var caption = root.querySelector('[data-selected-color-image-caption]');
    if (caption) caption.textContent = variant.public_title || variant.title || '';
  }

  function initRoot(root) {
    var scope = root.closest('.product-info') || document;
    var observeTarget = scope.querySelector('variant-picker') || scope;

    function sync() {
      applyVariant(root, readVariant(findVariantScript(scope)));
    }

    var observer = new MutationObserver(sync);
    observer.observe(observeTarget, { childList: true, subtree: true, characterData: true });

    ['variant:change', 'variant-change', 'change'].forEach(function (eventName) {
      document.addEventListener(eventName, function () { setTimeout(sync, 0); });
    });
  }

  function init() {
    document.querySelectorAll('[data-selected-color-image]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
